import "./Services.scss";
import { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import ServicesView from "./ServicesView";
import RecommendedServicesView from "./RecommendedServicesView";
import { usePermissions } from "../../hooks/usePermissions";

const Services = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const { hasPermission } = usePermissions();

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <div className="products">
      <Box sx={{ borderBottom: 1, borderColor: "divider", marginBottom: 2 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          aria-label="services tabs"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#1976d2",
            },
            "& .MuiTab-root": {
              fontSize: "16px",
              fontWeight: 600,
              textTransform: "none",
              minWidth: 120,
            },
            "& .Mui-selected": {
              color: "#1976d2",
            },
          }}
        >
          {hasPermission("44") &&       <Tab label="الخدمات" />}
    
          {hasPermission("110") &&    <Tab label="الخدمات المقترحة" />}
       
        </Tabs>
      </Box>

      {currentTab === 0 && <ServicesView />}
      {currentTab === 1 && <RecommendedServicesView />}
    </div>
  );
};

export default Services;